import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig"; // adjust path if needed

// ✅ Async thunk for submitting registration form
export const submitRegistrationForm = createAsyncThunk(
  "registration/submitRegistrationForm",
  async (formData, { rejectWithValue }) => {
    try {
      // Get token from localStorage
      const token = localStorage.getItem("token"); // replace "token" if your key is different

      const response = await axios.post(
        apiEndpoints.submitRegistrationFrom,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      // Capture API or network errors
      return rejectWithValue(
        error.response?.data || { detail: "Something went wrong" }
      );
    }
  }
);


export const updateRequirementStatus = createAsyncThunk(
  "requirements/updateStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        apiEndpoints.updateRequirementStatus, // define this in apiConfig.js
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          detail: "Failed to update requirement status",
        }
      );
    }
  }
);

// ✅ Slice definition
const registrationSlice = createSlice({
  name: "registration",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
    submittedData: null, // store fetched registrations
    fetchLoading: false,
    fetchError: null,
  },
  reducers: {
    resetRegistrationState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
    resetFetchedData: (state) => {
      state.submittedData = null;
      state.fetchLoading = false;
      state.fetchError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitRegistrationForm.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitRegistrationForm.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(submitRegistrationForm.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.detail || "Submission failed";
      });
    builder
      .addCase(updateRequirementStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRequirementStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(updateRequirementStatus.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error =
          action.payload?.detail || "Failed to update requirement status";
      });
  },
});

// ✅ Export actions and reducer
export const { resetRegistrationState, resetFetchedData } =
  registrationSlice.actions;
export default registrationSlice.reducer;
